module.exports = __webpack_public_path__ + "media/components/weather-icon/static/nightclear-6806a0742e8b8e91ec2f58b6ad61364d.png";